import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ALL_USER_GROUPS_QUERY } from "../../graphql/UserGroups/UserGroups.graphql";

function UserGroupSelect({ value, label, size, name, icon, onChange }) {
  const { data, loading, error } = useQuery(ALL_USER_GROUPS_QUERY);

  return (
    <Field>
      <Label size={size}>{label}</Label>
      <Control iconLeft size={size}>
        <Select.Container
          fullwidth
          color={error ? "danger" : ""}
          size={size}
          state={loading || !data ? "loading" : undefined}
        >
          <Select name={name} value={value} onChange={onChange}>
            <Select.Option value="">{label}</Select.Option>
            {!loading &&
              data.UserGroups.map((code, i) => (
                <Select.Option
                  key={`user-group-select-${i}`}
                  value={code.RecId}
                >
                  {`${code.GroupId} - ${code.Name}`}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
        {icon && (
          <Icon align="left" size={size}>
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
    </Field>
  );
}

UserGroupSelect.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  onChange: PropTypes.func
};

UserGroupSelect.defaultProps = {
  icon: "money-bill"
};
export default UserGroupSelect;
